import { AssetUnarchivedEvent } from '../event/asset-unarchived.event';
const assetUnarchivedProjections = {
    [AssetUnarchivedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            archived: payload.archived,
        };
    },
};
export default assetUnarchivedProjections;
//# sourceMappingURL=asset-unarchived.projection.js.map